import { darken } from "polished"
import { mediaQuery } from "shared/styles/mixins"
import styled from "styled-components"

import { BaseButton } from "./BaseButton"
import { ButtonProps } from "./types"

interface TextButtonProps extends ButtonProps {
  alt?: boolean
}

export const TextButton = styled(BaseButton).attrs((props) => ({
  type: props.type || "button",
}))<TextButtonProps>`
  color: ${(props) =>
    props.alt ? props.theme.colors.accent : props.theme.colors.dark};

  &:active {
    color: ${(props) =>
      props.alt
        ? darken(0.1, props.theme.colors.accent)
        : darken(0.1, props.theme.text.dark)};
  }

  &:hover {
    color: ${(props) =>
      props.alt
        ? darken(0.1, props.theme.colors.accent)
        : props.theme.colors.accent};
  }

  // To visually match the AccentButton, this button must be ever-so-slightly less tall
  height: ${(props) => `calc(${props.theme.input.height} - 4px)`};

  ${mediaQuery.mobileDevice} {
    height: ${(props) => `calc(${props.theme.mobile.input.height} - 4px)`};
  }
`
